
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91token_93QF5P0ABKs1r5bxD5p_FbzEXMAC1aBW_C04lWJh4VOEUMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/reset/[token].vue?macro=true";
import { default as deletion_45requestSsGwyfJXtH2lfr_p6GKe0HJ9w8AK1tZpA7b3XAJDijsMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/account/deletion-request.vue?macro=true";
import { default as user_45profileODkTAsn70k0DrFZ5wYgIJkawqBbHGH7_n_bht4v0zyoMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/account/user-profile.vue?macro=true";
import { default as complete_45activationPwdaHeqHMSzdmkakHOcF9FArBT4r62cHpuDBV9svEk0Meta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/complete-activation.vue?macro=true";
import { default as forgot_45passwordseySTPj_JNzPhMQZ_ao8xwdksns3uwQmpnncD8vHN3gMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/forgot-password.vue?macro=true";
import { default as human_45checkypm8QAy6uUuxb90U3r4GQaew6SLVMyBdenfA3u_XslcMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/human-check.vue?macro=true";
import { default as logoutJedV61pkDHL_WSc8jIZffeuCL5kjwjlwCzAjA3QNcu8Meta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/logout.vue?macro=true";
import { default as signinw_eX63c4kSkTZ2dKTrxTSUB_MfP7qRdZM9xDVugy9VMMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/signin.vue?macro=true";
import { default as signup6Qa4Tz2bVy5aDHwT1Z5wS6szMwtAtr8ef9NPW103PLQMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/signup.vue?macro=true";
import { default as verify_45email8oCf5NMYRRKvZpG4cTdFWmMtC3Eh7fYjfWMRjsCa4iAMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/verify-email.vue?macro=true";
import { default as newtfGEoZGiZNndQcmD0DKgEy41J0aL9XByEF_CXlFqJhAMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/number-registrations/new.vue?macro=true";
import { default as _91numberId_93Lfhpu6J8JtI62DdKEMrZlgLk2UZqhkxtuxmvNj47YI0Meta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/number-registrations/[numberId].vue?macro=true";
import { default as indexlP28z_iDYu9_J7yS9h2aLZtloNMoy9F_S50WvL9Tr0AMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/account-deletion/index.vue?macro=true";
import { default as billingcnCP7dLgqkt47Hmi7fvKa1fbt0XJAW2oUalIQlQ5jmcMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/billing.vue?macro=true";
import { default as calls56SpTCbn7H43NufXWwiIOTgCJkpNuNpLHVyYNpb59joMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/calls.vue?macro=true";
import { default as contactsUbbNmUiHEhTGUBddBmozVEPIGZ75obFQ0yc2mW_QENMMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/contacts.vue?macro=true";
import { default as dashboardi5KlOpc_BhlVAG09zXu4GcCS_QrlaQ_E5553ADxlO6EMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/dashboard.vue?macro=true";
import { default as linked_45devices52E7WwgojmiZS73G_1pB58dZOeWtHui29Mt6dGDvARAMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/linked-devices.vue?macro=true";
import { default as messagesz__NRkkhF7jFnNaGsJdj0EzSX0A2OFBY5o4oqG91ogAMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/messages.vue?macro=true";
import { default as notificationsf6mSV9mICnXaM5QwNO6Xrx3XVmuSlNED3ErIgc1fxe8Meta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/notifications.vue?macro=true";
import { default as indexwhJHIIGAAsxDmEDG9dSAtEYVWKVhzEWO6ueehHm13B4Meta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/number-registrations/index.vue?macro=true";
import { default as index4hmCybQbXQJ1jXroEDcCLaePTSF8YIvhnU66ZAW6sk4Meta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/numbers/index.vue?macro=true";
import { default as scheduled_45callsH5HUmlZcS4jvGeoT1C273BBluGLdm8d_56RiLBBOS8IMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/scheduled-calls.vue?macro=true";
import { default as select_45numberpZafUlWMqdrxJTGBKvK24fTanvfsTSdY1e0NILfadbAMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/select-number.vue?macro=true";
import { default as supportR8Oi3SAKRi2HBdzDbWeOr8HSOwlptdTkdPuhNZtVAHAMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/support.vue?macro=true";
import { default as teamsnjJKi_S6vZAhXo6iDbRT_C7B9f7Ilv1c2XcBPDyuyRMMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/teams.vue?macro=true";
import { default as indexK2LrOJd5WIrq_CjS_W84Cz2CjQw3AT6RYV8L5xQ2kDcMeta } from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/index.vue?macro=true";
export default [
  {
    name: "auth-reset-token",
    path: "/auth/reset/:token()",
    meta: _91token_93QF5P0ABKs1r5bxD5p_FbzEXMAC1aBW_C04lWJh4VOEUMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/reset/[token].vue")
  },
  {
    name: "account-deletion-request",
    path: "/account/deletion-request",
    meta: deletion_45requestSsGwyfJXtH2lfr_p6GKe0HJ9w8AK1tZpA7b3XAJDijsMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/account/deletion-request.vue")
  },
  {
    name: "account-user-profile",
    path: "/account/user-profile",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/account/user-profile.vue")
  },
  {
    name: "auth-complete-activation",
    path: "/auth/complete-activation",
    meta: complete_45activationPwdaHeqHMSzdmkakHOcF9FArBT4r62cHpuDBV9svEk0Meta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/complete-activation.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordseySTPj_JNzPhMQZ_ao8xwdksns3uwQmpnncD8vHN3gMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-human-check",
    path: "/auth/human-check",
    meta: human_45checkypm8QAy6uUuxb90U3r4GQaew6SLVMyBdenfA3u_XslcMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/human-check.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/logout.vue")
  },
  {
    name: "auth-signin",
    path: "/auth/signin",
    meta: signinw_eX63c4kSkTZ2dKTrxTSUB_MfP7qRdZM9xDVugy9VMMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/signin.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    meta: signup6Qa4Tz2bVy5aDHwT1Z5wS6szMwtAtr8ef9NPW103PLQMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/signup.vue")
  },
  {
    name: "auth-verify-email",
    path: "/auth/verify-email",
    meta: verify_45email8oCf5NMYRRKvZpG4cTdFWmMtC3Eh7fYjfWMRjsCa4iAMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/auth/verify-email.vue")
  },
  {
    name: "number-registrations-new",
    path: "/number-registrations/new",
    meta: newtfGEoZGiZNndQcmD0DKgEy41J0aL9XByEF_CXlFqJhAMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/number-registrations/new.vue")
  },
  {
    name: "number-registrations-numberId",
    path: "/number-registrations/:numberId()",
    meta: _91numberId_93Lfhpu6J8JtI62DdKEMrZlgLk2UZqhkxtuxmvNj47YI0Meta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/number-registrations/[numberId].vue")
  },
  {
    name: "account-deletion",
    path: "/account-deletion",
    meta: indexlP28z_iDYu9_J7yS9h2aLZtloNMoy9F_S50WvL9Tr0AMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/account-deletion/index.vue")
  },
  {
    name: "billing",
    path: "/billing",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/billing.vue")
  },
  {
    name: "calls",
    path: "/calls",
    meta: calls56SpTCbn7H43NufXWwiIOTgCJkpNuNpLHVyYNpb59joMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/calls.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    meta: contactsUbbNmUiHEhTGUBddBmozVEPIGZ75obFQ0yc2mW_QENMMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/contacts.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/dashboard.vue")
  },
  {
    name: "linked-devices",
    path: "/linked-devices",
    meta: linked_45devices52E7WwgojmiZS73G_1pB58dZOeWtHui29Mt6dGDvARAMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/linked-devices.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/messages.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/notifications.vue")
  },
  {
    name: "number-registrations",
    path: "/number-registrations",
    meta: indexwhJHIIGAAsxDmEDG9dSAtEYVWKVhzEWO6ueehHm13B4Meta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/number-registrations/index.vue")
  },
  {
    name: "numbers",
    path: "/numbers",
    meta: index4hmCybQbXQJ1jXroEDcCLaePTSF8YIvhnU66ZAW6sk4Meta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/numbers/index.vue")
  },
  {
    name: "scheduled-calls",
    path: "/scheduled-calls",
    meta: scheduled_45callsH5HUmlZcS4jvGeoT1C273BBluGLdm8d_56RiLBBOS8IMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/scheduled-calls.vue")
  },
  {
    name: "select-number",
    path: "/select-number",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/select-number.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/support.vue")
  },
  {
    name: "teams",
    path: "/teams",
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/teams.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexK2LrOJd5WIrq_CjS_W84Cz2CjQw3AT6RYV8L5xQ2kDcMeta || {},
    component: () => import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/pages/index.vue")
  }
]